module.exports = __webpack_public_path__ + "static/media/manager.36004f3f.svg";